import {
  Box,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  useBreakpointValue,
  Divider,
  typography,
  Grid,
} from "@chakra-ui/react";

import { SearchIcon } from "@chakra-ui/icons";

import React, { useState } from "react";
import { Link } from "gatsby";
import Logo from "./Logo";
import useSearch from "../hooks/useSearch";
import Item from "./Item";

function SearchBox() {
  const color = useColorModeValue("gray.700", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const size = useBreakpointValue({ base: "full", md: "xl" });
  const context = useSearch();
  const [searchResult, setSearchResult] = useState([]);

  return (
    <Box
      color={color}
      display="flex"
      justifyContent="space-between"
      pt={2}
      position="relative"
      px={4}
      mt={2}
    >
      <Modal
        onClose={onClose}
        size={size}
        isOpen={isOpen}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>🔎 Encuentra tu momazo...</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <Input
                autoComplete="off"
                placeholder="Buscar"
                type="search"
                onChange={(evt) => {
                  if (evt.target.value.length >= 3) {
                    setSearchResult(context.searchAction(evt.target.value));
                  } else {
                    setSearchResult([]);
                  }
                }}
              />
            </FormControl>
            <Divider />
            <Box mt={2}>
              <Grid
                templateColumns={{
                  base: `repeat(1, 100%)`,
                  md: `repeat(2, 49%)`,
                }}
                gap={{
                  base: 2,
                }}
              >
                {searchResult.map((item: any) => (
                  <Box>
                    <Item
                      node={{
                        data: {
                          Name: item.name,
                          Attachments: item.image,
                          tags: item.tags,
                        },
                      }}
                      loading="lazy"
                      hideText
                    />
                  </Box>
                ))}
              </Grid>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar 😭</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Link aria-label="volver al inicio" to="/">
        <Logo width={150} height={45} />
      </Link>
      <Box>
        <Button variant="ghost" aria-label="Buscar momazo" onClick={onOpen}>
          <SearchIcon />
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBox;
